import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

// we will connect our reducers here
import { OrderReducer } from './OrderReducer';

const appReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    orders: OrderReducer,
  });

const createRootReducer = (history) => (state, action) => {
  if (action.type === 'LOGOUT_REQUEST') {
    state = undefined;
  }
  return appReducer(history)(state, action);
};

export default createRootReducer;
